import React from 'react';
import { useAtom } from 'jotai';
import { stepAtom } from '../atoms';
import { FirstStep } from '../FirstStep';
import { SecondStep } from '../SecondStep';
import { Step } from '../constants';

export const StepSwitcher = () => {
  const [step] = useAtom(stepAtom);

  switch (step) {
    case Step.FIRST_STEP:
      return <FirstStep />;
    case Step.SECOND_STEP:
      return <SecondStep />;
    default:
      return null;
  }
};
